<template>
  <v-container fluid>
    <v-row class="justify-center">
      <v-col sm="12">
        <h1 class="headline">
          Department of Buildings - Applications
        </h1>
        <div class="caption grey--text text--darken-1">
          {{ description }}
        </div>
      </v-col>
    </v-row>

    <v-row class="justify-center">
      <v-col sm="12">
        <v-card>
          <v-tabs>
            <v-tab @click="getData()">14 Days Back</v-tab>
            <v-tab @click="get2021Data()">2021 without permit</v-tab>
            <v-tab @click="get2020Data()">2020 without permit</v-tab>
            <v-tab @click="get2019Data()">2019 without permit</v-tab>
          </v-tabs>
          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :search="search"
            :items="dobData"
            :loading="loading"
            sort-by="sortDate"
            sort-desc
            loading-text="Loading Projects from DOB..."
            :items-per-page="50"
          >
            <template v-slot:top>
              <v-toolbar flat color="white" class="pt-1">
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Filter"
                  hide-details
                  outlined
                  dense
                ></v-text-field>
              </v-toolbar>
            </template>
            <template v-slot:item.filing_date="{ item }">
              {{ item.formattedDate || item.pre__filing_date }}
            </template>
            <template v-slot:item.job__="{ item }">
              {{ item.job__ }} {{ item.job_type }}
            </template>
            <template v-slot:item.filing_status="{ item }">
              {{ item.filing_status || item.job_status }}
            </template>
            <template v-slot:item.owner_shouse_street_name="{ item }">
              <div class="capitalize">
                {{ item.house_no ? item.house_no.toLowerCase() : "" }}
                {{ item.street_name ? item.street_name.toLowerCase() : ""
                }}<br /><span class="">{{ item.borough.toLowerCase() }}</span>
              </div>
            </template>
            <template v-slot:item.job_description="{ item }">
              <div class="grey--text text--darken-2">
                {{
                  item.job_description ? item.job_description.toLowerCase() : ""
                }}
              </div>
            </template>
            <template v-slot:item.owner_s_first_name="{ item }">
              <div class="capitalize">
                {{
                  item.owner_s_first_name
                    ? item.owner_s_first_name.toLowerCase()
                    : ""
                }}
                {{
                  item.owner_s_last_name
                    ? item.owner_s_last_name.toLowerCase()
                    : ""
                }}<br /><span class="grey--text text--darken-2"
                  ><em>{{
                    item.owner_s_business_name
                      ? item.owner_s_business_name.toLowerCase()
                      : ""
                  }}</em></span
                ><br />
              </div>
            </template>
            <template v-slot:item.building_class="{ item }">
              <v-btn
                color="primary"
                text
                outlined
                small
                target="_blank"
                :href="
                  `http://a810-bisweb.nyc.gov/bisweb/JobsQueryByNumberServlet?requestid=2&passjobnumber=${item.job__}&passdocnumber=01`
                "
                >view</v-btn
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import axios from "axios";
export default {
  data: () => ({
    search: "",
    date: new Date().toISOString().substr(0, 10),
    dobData: [],
    loading: true,
    description:
      "Shows the last 14 days of demolition applications submitted to the DOB.",
    headers: [
      //   {
      //     text: "ID",
      //     align: "left",
      //     sortable: false,
      //     value: "job__",
      //     width: 140,
      //   },
      { text: "Date", value: "filing_date", width: "100" },
      { text: "Address", value: "owner_shouse_street_name", width: "220" },
      { text: "Status", value: "filing_status", align: "left", width: "260" },
      {
        text: "Description",
        value: "job_description",
        align: "left",
      },
      {
        text: "Owner Details",
        value: "owner_s_first_name",
        align: "left",
        width: "250",
      },
      {
        text: "",
        value: "building_class",
        align: "right",
        width: "100",
      },
    ],
  }),
  async created() {
    this.getData();
  },
  methods: {
    async getData() {
      try {
        const { data } = await axios.get(
          "https://data.cityofnewyork.us/resource/w9ak-ipjd.json?$WHERE=job_type=%27Full%20Demolition%27&$order=filing_date%20DESC"
        );
        this.description =
          "Shows the last 14 days of demolition applications submitted to the DOB.";
        this.dobData = data.map((d) => {
          return {
            ...d,
            sortDate: moment(d.filing_date).unix(),
            formattedDate: moment(d.filing_date).format("MM/DD/YYYY"),
          };
        });
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    refreshList() {
      this.loading = true;
      this.getData();
    },
    async get2019Data() {
      this.loading = true;
      this.dobData = [];
      const res = await axios.get(
        "https://data.cityofnewyork.us/resource/ic3t-wcy2.json?$where=pre__filing_date%20like%20%27%252019%25%27%20AND%20job_type%20=%20%27DM%27%20AND%20job_status%20not%20in(%27Q%27,%20%27R%27,%20%27U%27,%20%27X%27,%20%273%27)"
      );
      this.loading = false;
      this.description =
        "2019 demolition applications where no permit was issued.";
      this.dobData = res.data.filter((d) => {
        return (
          !["Q", "R", "U", "X", "3"].includes(d.job_status) &&
          d.pre__filing_date.includes("2019")
        );
      });
    },
    async get2020Data() {
      this.loading = true;
      this.dobData = [];
      const res = await axios.get(
        "https://data.cityofnewyork.us/resource/ic3t-wcy2.json?$where=pre__filing_date%20like%20%27%252020%25%27%20AND%20job_type%20=%20%27DM%27%20AND%20job_status%20not%20in(%27Q%27,%20%27R%27,%20%27U%27,%20%27X%27,%20%273%27)"
      );
      this.loading = false;
      this.description =
        "2020 demolition applications where no permit was issued.";
      this.dobData = res.data.filter((d) => {
        return (
          !["Q", "R", "U", "X", "3"].includes(d.job_status) &&
          d.pre__filing_date.includes("2020")
        );
      });
    },
    async get2021Data() {
      this.loading = true;
      this.dobData = [];
      const res = await axios.get(
        "https://data.cityofnewyork.us/resource/ic3t-wcy2.json?$where=pre__filing_date%20like%20%27%252021%25%27%20AND%20job_type%20=%20%27DM%27%20AND%20job_status%20not%20in(%27Q%27,%20%27R%27,%20%27U%27,%20%27X%27,%20%273%27)"
      );
      this.loading = false;
      this.description =
        "2021 demolition applications where no permit was issued.";
      this.dobData = res.data.filter((d) => {
        return (
          !["Q", "R", "U", "X", "3"].includes(d.job_status) &&
          d.pre__filing_date.includes("2021")
        );
      });
    },
  },
};
</script>

<style scoped>
.capitalize {
  text-transform: capitalize;
}
</style>
